define.alias("ember-composable-helpers/helpers/has-previous", "preview-grid/helpers/has-previous");